import React from 'react';
import WidgetContent from '../WidgetContent';
import Page from './Page';
import PageFooter from './PageFooter';
import PageHeader from './PageHeader';

class PageWidget extends React.PureComponent {
    render() {
        const {analytics, dashboard, dates, type, params, organization, hints} = this.props;
        if (!analytics || analytics.loading) {
            return null;
        }
        const instanceType = new URLSearchParams(window.location.search).get('instanceType');
        return (
            <Page className="d-flex flex-column justify-content-between">
                <PageHeader dashboard={dashboard} dates={dates} organization={organization} />
                <WidgetContent type={type} params={params} data={analytics.data} error={analytics.error} hints={hints} instanceType={instanceType} />
                <PageFooter />
            </Page>
        );
    }
}

export default PageWidget;
